import React, { useMemo } from 'react';
import './ChangeRequestTitle.less';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import { useAgentSelector } from '../../../hooks/useAgentStore';
import { LockOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { NOT_OWN_CHANGE_REQUEST } from '../../../constants/texts';
import {
  getChangeRequestTitle,
  isOwnChangeRequest,
} from '../../../services/changeRequestService';

const ChangeRequestTitle: React.FC = () => {
  const org = useSelector((state: RootState) => state.organization.org);
  const { data } = useAgentSelector((state) => state.changeRequest);
  const changeRequest = useMemo(() => {
    return data?.result || null;
  }, [data]);

  const showLockIcon =
    !!changeRequest && !isOwnChangeRequest(org, changeRequest);
  const title = changeRequest
    ? getChangeRequestTitle(changeRequest)
    : 'CR-****';
  return (
    <div id="change-request-title">
      <div className="change-request-subtitle">Change Request</div>
      <div className="change-request-title-container">
        {showLockIcon && (
          <Tooltip title={NOT_OWN_CHANGE_REQUEST}>
            <LockOutlined className="change-request-title-lock-icon" />
          </Tooltip>
        )}
        <div className="change-request-title-text">{title}</div>
      </div>
    </div>
  );
};

export default ChangeRequestTitle;
